import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { ThemeProvider } from "@/lib/ThemeProvider.tsx";
import PWABadge from "@/components/PWABadge.tsx";
import * as Sentry from "@sentry/react";
import { processQueue } from "@/api/queue.ts";

const bugsinkDsn = import.meta.env.VITE_BUGSINK_DSN;

window.addEventListener("online", () => processQueue());

if (bugsinkDsn) {
	Sentry.init({
		dsn: bugsinkDsn,
		release: "tawnylist-client@" + import.meta.env.COMMIT_SHA,
		integrations: [],
		tracesSampleRate: 0,
	});
}

ReactDOM.createRoot(document.getElementById("root")!).render(
	<ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
		<div className={"min-h-screen bg-background"}>
			<PWABadge />
			<App />
		</div>
	</ThemeProvider>,
);
